var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HEADER") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 21,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFaADAAQAAAABAAAAFQAAAAAIGxIOAAADoUlEQVQ4EbVVO2xcVRCdue/tx8GggPxByBLr3fUzwSkInwaRAiSI+ThaEFsS0dDSIKXgI7kIBSDRQEMDoV4ITqQYAk2KSHQgFwF72V1v4SK2ATmQj71v3wxnnvcu68hRRMFIb+/Mnbln53svU48Khdfz2WBrVoVnmHWSSO8i5oCUQ2UKzIyVEvx0STWBdF2VV9np5U5y8Lt2+/S2x2JjHipUCuLoXQhjAkQWvUlMNwF8HYd38KV2u4c0h/UAKQ2p4yEHZCXacEKnltsLbbPhcvn5nNPsJ0puHGA/cFa+XFk597cp70TT08fv1phfU3bHmGS9k9z7pnkcAvAF+HY/Qvq+vrrw6Z2AvP7Q5CsPSid54tqOnB7Owzvi2YzbehH6rx1y9pQZZjTzlT9w6zoxUR0yrwb3uyxPIisnhvPByYSdP5tihUo6jn/pXG7X1gcPEc27qPjzM8TuaaXuYYodR8XKhqiebaxmFwPp/CnONQLlL+qtM5tRqbLtlMYMI2TmDLz9HTzy7WneTZWW3kJajqpqDM2SMmeZtBwwvxEV40eXW9lTRLUL/gRsNtEloyaHAMwgIXsKMz3500uk7ijCW0HvfNRsfbNhxqXSy2Oo9tuO6LGoFM/Vm7Rg+0bw6Bra4AHjnfWgqnRN8KQumAPfSTj8sNncBTSd8bHQvOkQxXGs/VZDxF0IaT876zN4lIFBSlYQVh0XpV8ajdqm3/dru72wBbd+hW8jxWL1Hr+PNIU9nhHJ/sQO03Qbkl7+ReK+p4OmziYIPRr7TWt8FGVdlaKZiep9ft+vUTQ34pgeBvAmvL7q9y38Ho9BwzwzO+96ui8i59DAuTgbv4OJ64dYLldHOXYnYZRFOs9j7XeMhQ8BdbXqs7UM72nsxuqR81Fx6Qha6PFAcp9PFStNTH9AEpeQ/wCHf/ytFZ41AE/IwzDKlkaMOlnoOgLlQH7mpd4K30fGP0aYa0j8IUQUweYPIfdZvfXIB+jR1KseKIpNo7BJQUNINklTM4XqOKbqSs8ISy1ZbtBFMBctBUGQ0Xr/ojnzrxk49C8ANa/Ea6aw8C8h/KmY41ch73uhNBrf/mXGt6NABWeRLKJLZhMKdxad5GZRsmejyQr956uvE5xApz9HJFfi5OCigaZ5tGssYXkPwu4lTbqNv70BPT67pAdJrPJ4FegAws3ve0l7c3tOcuHVY5LQ4b3PCcaYOW055K0LsOTW5+TGTubC2loNL8X/SP8AYj2UbilYR/8AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HEADER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Instagram",
    href: "#img1",
    transform: "matrix(1,0,0,1,0,0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.21c2ccdd508ef6de4a0c29536578a86c.svg";
export { ForwardRef as ReactComponent };